/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import primaryComponents from "../../../../../../components/primaryComponents";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { PlusIcon } from "../../../../../../assets/svgIcons";
import { useAllGoodsReceived } from "./useAllGoodsReceived";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../../routes/pathContants";
import { GRNTable } from "../../../../../../components/secondaryComponents/GoodsReceived";

export const AllGoodsReceived = () => {
  const {
    search,
    storeList,
    goodsReceivedStatus,
    goodsReceived,
    isLoadingGRN,
    isLoadingExtra,
    metaDetails,
    suppliers,
    filterByDate,
    filterByStoreId,
    filterBySearch,
    gotoPage,
    filterByKey,
  } = useAllGoodsReceived();
  const navigate = useNavigate();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Goods Recieved Notes"
      description="View of all goods received note"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Goods Received</h4>
            <p>
              Record items delivered and match them against your purchase
              orders.
            </p>
          </div>

          <div className={globalStyles.rowNavigations}>
            {goodsReceivedStatus?.map((item, index) => (
              <a
                key={index}
                className={`${globalStyles.rowNavigations__item} ${
                  search.get("status") === item?.value
                    ? globalStyles.active
                    : ""
                }`}
                onClick={() => filterByKey("status", item?.value)}
              >
                {item?.label}{" "}
                {item?.value === "IN_REVIEW" ? (
                  <span className={`ml-1 ${globalStyles.noOfPends}`}>
                    {metaDetails?.total_in_review || 0}
                  </span>
                ) : null}
              </a>
            ))}
          </div>

          <div className={globalStyles.pageHeaders}>
            <p style={{ textTransform: "lowercase" }}>
              {metaDetails?.total} {search.get("status")?.replace("_", " ")}
            </p>

            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey={"can_create_or_update_goods_received"}
            >
              <primaryComponents.Button
                classNames={"btn btn--primary ml-auto"}
                onClick={() =>
                  navigate(pathConstants.INVENTORY_GOODS_RECEIVED_CREATE)
                }
              >
                <PlusIcon className="mr-1" /> Recieve Goods
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>

          {/* table section */}
          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                classNames={`${globalStyles.searchField}`}
                placeholder="Search by GRN number, PO number or supplier"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") || ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />

              <secondaryComponents.LoaderHelper
                isLoading={isLoadingExtra}
                classNames="mt-2"
              >
                <div className="ml-auto" style={{ width: "140px" }}>
                  <primaryComponents.SelectField
                    options={[
                      {
                        name: "All stores",
                        id: null,
                      },
                      ...storeList,
                    ]}
                    idKey="id"
                    nameKey="name"
                    onChange={(value) => {
                      filterByStoreId(value);
                    }}
                    value={
                      storeList?.find(
                        (store) => `${store?.id}` === search.get("store_id"),
                      )?.name || "Filter store"
                    }
                    floatError={false}
                    isSearchable={false}
                  />
                </div>
                <div style={{ width: "160px" }}>
                  <primaryComponents.SelectField
                    options={[
                      {
                        name: "All suppliers",
                        id: null,
                      },
                      ...suppliers,
                    ]}
                    idKey="id"
                    nameKey="name"
                    onChange={(value) => {
                      filterByKey("supplier_id", value);
                    }}
                    value={
                      storeList?.find(
                        (store) => `${store?.id}` === search.get("supplier_id"),
                      )?.name || "Filter Supplier"
                    }
                    floatError={false}
                    isSearchable={false}
                  />
                </div>

                <primaryComponents.DateRangeInput
                  startDate={search.get("start_date")}
                  endDate={search.get("end_date")}
                  onChange={filterByDate}
                  showPlaceholder={true}
                />
              </secondaryComponents.LoaderHelper>
            </div>

            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingGRN}
              classNames="mt-5"
            >
              <GRNTable
                goodsReceived={goodsReceived}
                metaDetails={metaDetails}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
